'use client';

import Link from 'next/link';
import { trackEvent } from '@/lib/analytics';
import {
  EXPLORE_BREADCRUMB_CLICKED,
  type ExploreBreadcrumbClickedProps,
} from '@/lib/analytics/explore-events';

type Props = {
  level: ExploreBreadcrumbClickedProps['level'];
  fromPage: string;
  toPage: string;
  href: string;
  className?: string;
  children: React.ReactNode;
} & Record<string, unknown>;

export function TrackedBreadcrumbLink({ level, fromPage, toPage, href, className, children, ...rest }: Props) {
  return (
    <Link
      href={href}
      className={className}
      onClick={() =>
        trackEvent(EXPLORE_BREADCRUMB_CLICKED, {
          level,
          from_page: fromPage,
          to_page: toPage,
        })
      }
      {...rest}
    >
      {children}
    </Link>
  );
}
